import { useAuth } from '../auth/AuthProvider';
import { isSuperAdmin, useMyPermissions } from '../auth/useMyPermissions';

/** Convenience visibility only. The RPC rechecks active effective access. */
export function useJourneyAdmin() {
  const { access } = useAuth();
  const permissions = useMyPermissions();
  return (
    access.status === 'approved' &&
    access.profile.account_type === 'tap' &&
    (access.profile.internal_role === 'tap_admin' || isSuperAdmin(permissions.data))
  );
}
